import { useSelector } from 'react-redux';
import { getUpdatedHeaderFlag } from '@/selectors/configSelectors';
import {
  TclMigrationFeatures,
  getTCLFeatureFlagsFromState,
  isTCLFeatureEnabled,
  flagToBool,
  type TCLFeatures,
} from '@/helpers/featureFlagHelper';
import { supportedLocales } from '@/constants/supportedLocales';
import { useRouteParams } from '@/context/routeParamsContext';

export type Locale = Lowercase<(typeof supportedLocales)[number]>;
type UseTclFeatureFlags = (feature: TCLFeatures) => boolean;

export { TclMigrationFeatures };

export const useTCLFeatureFlags: UseTclFeatureFlags = (
  feature: TCLFeatures
) => {
  const { locale } = useRouteParams() as { locale: Locale };
  const featureFlags = useSelector(getTCLFeatureFlagsFromState);

  return isTCLFeatureEnabled({
    feature,
    locale,
    featureFlags,
  });
};

export const useUpdatedHeaderEnabledFlag = (): boolean => {
  const flag = useSelector(getUpdatedHeaderFlag);
  return flagToBool(flag);
};
